import { useCallback, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getCustomerDetails } from "../services";
import { CustomerResponse } from "../types/customer.type";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CustomerDetails from "../components/Customer/Details";

export default function CustomerDetailsPage() {
  const { customerId } = useParams<{ customerId: string }>();
  const [customerDetails, setCustomerDetails] = useState<CustomerResponse>();

  const getDetails = useCallback(async (customerId: string) => {
    const {
      data: { data },
    } = await getCustomerDetails(customerId);

    setCustomerDetails(data);
  }, []);

  useEffect(() => {
    customerId && getDetails(customerId);
  }, [customerId, getDetails]);

  if (!customerDetails) return null;

  return (
    <Box sx={{ padding: "8px 0" }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <Link
          to="/customer"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            ลูกค้า
          </Typography>
        </Link>
        <Typography variant="body1" sx={{ mx: 1 }}>
          /
        </Typography>
        <Typography variant="body1" color="primary">
          {customerDetails.name}
        </Typography>
      </Box>
      <CustomerDetails
        customerDetails={customerDetails}
        onUpdated={() => customerId && getDetails(customerId)}
      />
    </Box>
  );
}
